import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from './views/Dashboard.vue'
import Login from './views/Login.vue'
import PasswordLogin from './views/PasswordLogin.vue'
import ResetPassword from './views/ResetPassword.vue'
import Formulario from './views/Formulario.vue'

Vue.use(Router)

function check_login(to, from, next) {
	if (typeof Storage !== 'undefined') {
		if (
			localStorage.mgf_login !== undefined &&
			localStorage.mgf_password !== undefined
		) {
			next()
		} else {
			next('/login')
		}
	}
}

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/login',
			name: 'login',
			component: Login,
		},
		{
			path: '/login/solicitacao',
			name: 'Formulario',
			component: Formulario,
		},
		{
			path: '/forgot_login',
			name: 'forgot_login',
			component: PasswordLogin,
		},
		{
			path: '/forgot_login/reset_password',
			name: 'reset_password',
			component: ResetPassword,
		},
		{
			path: '/login',
			name: 'adv_login',
			component: Login,
		},
		{
			path: '/',
			redirect: '/home',
		},
		{
			path: '/home',
			name: 'home',
			component: () => import('./views/Actions.vue'),
			beforeEnter: check_login,
		},
		// {
		// 	path: '/generatorLink',
		// 	name: 'generatorLink',
		// 	component: () => import('./views/GeneratorLink.vue'),
		// 	beforeEnter: check_login,
		// },
		{
			path: '/campaigns',
			name: 'campaigns',
			component: () => import('./views/Campaigns.vue'),
			beforeEnter: check_login,
		},
		{
			path: '/tools',
			name: 'tools',
			component: () => import('./views/Tools.vue'),
			beforeEnter: check_login
		},
		// {
		// 	path: '/shortLink',
		// 	name: 'shortLink',
		// 	component: () => import('./views/ShortLink.vue'),
		// 	beforeEnter: check_login,
		// },
		// {
		// 	path: '/statsShortLink',
		// 	name: 'statsShortLink',
		// 	component: () => import('./views/StatsShortLink.vue'),
		// 	beforeEnter: check_login,
		// },
		{
			path: '/purchases',
			name: 'purchases',
			component: () => import('./views/Purchases.vue'),
			beforeEnter: check_login,
		},
		{
			path: '/visits',
			name: 'visits',
			component: () => import('./views/Visits.vue'),
			beforeEnter: check_login,
		},
		{
			path: '/dashboard',
			name: 'dashboard',
			component: Dashboard,
			beforeEnter: check_login,
		},
		{
			path: '/commissions',
			name: 'commissions',
			component: () => import('./views/Commissions.vue'),
			beforeEnter: check_login,
		},
		{
			path: '/advertisers',
			name: 'anunciante',
			component: () => import('./views/Anunciante.vue'),
			beforeEnter: check_login,
		},
		{
			path: '/settings',
			name: 'setting',
			component: () => import('./views/Settings.vue'),
			beforeEnter: check_login,
		},
	],
})
